import {KTSVG} from '../../../../_metronic/helpers/components/KTSVG'
import * as Yup from 'yup'
import {useAuth} from '../../auth'
import {useFormik} from 'formik'
import {initTicketCreateValues, ITicketCreate} from '../_model'
import clsx from 'clsx'
import AttachmentMultiple from '../../../utils/components/AttachementMultiple'
import {useState} from 'react'
import axios, {AxiosError} from 'axios'
import {BASE_URL} from '../../config'
import toast from 'react-hot-toast'
import {
  base64ToFile,
  getMimeTypeFromBase64,
  handleAxiosError,
} from '../../../utils/helperFunction/_helper'
import {useMutation, useQueryClient} from 'react-query'
import RichTextEditor from '../../../utils/components/rich-text-editor/RichTextEditor'

const ticketSchema = Yup.object().shape({
  ticketMessage: Yup.string().required('Ticket message is required'),
  ticketSubject: Yup.string().required('Ticket subject is required'),
})

export const MAX_FILE_SIZE = 500 * 1024 // 100 KB
const CREATE_TICKET_URL = `${BASE_URL}/api/protect/createTicket`
// const ADD_TICKET_ATTACHMENTS = `${BASE_URL}/api/protect/addTicketReplyAttachments?ticketId=`
const ADD_TICKET_ATTACHMENTS = `${BASE_URL}/api/protect/addTicketAttachments?ticketId=`

const createTicket = async (data: Partial<ITicketCreate>) => {
  const response = await axios.post(CREATE_TICKET_URL, data)
  return response
}

const NewTicketModal = () => {
  const queryClient = useQueryClient()
  const {currentUser} = useAuth()
  const [previewUrls, setPreviewUrls] = useState<string[]>([])

  const {mutate: createNewTicket} = useMutation({
    mutationKey: ['ticketList'],
    mutationFn: async ({sendValues}: {sendValues: Partial<ITicketCreate>}) => {
      toast.loading('Processing..')
      const response = await axios.post(CREATE_TICKET_URL, sendValues)

      if (sendValues.isAttachment === '1' && response.status === 200) {
        const formData = new FormData()

        formik.values.attachment.forEach((file: string, index: number) => {
          const mime = getMimeTypeFromBase64(file) // e.g. "image/jpeg"
          const ext = mime.split('/')[1] || 'png' // e.g. "jpeg"
          const filename = `file_${index}.${ext}`

          const newFile = base64ToFile(file, filename)
          formData.append('attaachemt', newFile)
        })

        await axios.post<{message: string; status: string; statuscode: number}>(
          `${ADD_TICKET_ATTACHMENTS}${response.data.ticketId}`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        )
      }
    },
    onSuccess: (values) => {
      toast.dismiss()
      toast.success('Successfully Created')
      console.log(values)
      queryClient.invalidateQueries(['ticketList'])
      resetForm()
    },
    onError: (error) => {
      toast.dismiss()
      console.log(error)
      const message = handleAxiosError(error)
      toast.error(message)
    },
  })

  const formik = useFormik({
    initialValues: {...initTicketCreateValues, mailTo: currentUser?.userEmail},
    validationSchema: ticketSchema,
    onSubmit: async (values) => {
      try {
        console.log(values)
        let sendData: Partial<ITicketCreate> = {
          ticketMessage: values.ticketMessage,
          mailTo: values.mailTo,
          mailToCC: values.mailToCC,
          ticketSubject: values.ticketSubject,
          isAttachment: values.attachment.length > 0 ? '1' : '0',
        }

        await createNewTicket({sendValues: sendData})

        // const response = await createTicket(sendData)
        // const data = await response.data
        // console.log(response)

        // if (response.status === 200 && sendData.isAttachment === '0') {
        //   toast.dismiss()
        //   toast.success('Ticket created successfully')
        //   resetForm()
        // }

        // if (sendData.isAttachment === '1' && response.status === 200) {
        //   console.log(data.ticketId)

        //   const formData = new FormData()

        //   formik.values.attachment.forEach((file: string, index: number) => {
        //     const newFile = base64ToFile(file, `file_${index}`)
        //     formData.append('attaachemt', newFile)
        //   })

        //   const res = await axios.post<{message: string; status: string; statuscode: number}>(
        //     `${ADD_TICKET_ATTACHMENTS}${data.ticketId}`,
        //     formData,
        //     {
        //       headers: {
        //         'Content-Type': 'multipart/form-data',
        //       },
        //     }
        //   )

        //   if (res.status === 200) {
        //     toast.dismiss()
        //     toast.success(res.data.message)
        //     resetForm()
        //   }
        // }
      } catch (error) {
        toast.dismiss()
        console.log(error)
        const message = handleAxiosError(error)
        toast.error(message)
      }
    },
  })

  const onContentChange = (content: string) => {
    formik.setFieldValue('ticketMessage', content)
  }

  const resetForm = () => {
    formik.resetForm()
    setPreviewUrls([])
  }

  return (
    <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
      <div className='modal-dialog modal-lg'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title fs-2'> Create New Ticket</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            <form onSubmit={formik.handleSubmit}>
              <div className='fv-row mb-7'>
                <label className='required fw-semibold fs-5 mb-2'>Subject</label>

                <input
                  placeholder='Ticket subject'
                  {...formik.getFieldProps('ticketSubject')}
                  type='text'
                  name='ticketSubject'
                  className={clsx(
                    'form-control form-control custom-input mb-3 mb-lg-0',
                    {
                      'is-invalid': formik.touched.ticketSubject && formik.errors.ticketSubject,
                    },
                    {
                      'is-valid': formik.touched.ticketSubject && !formik.errors.ticketSubject,
                    }
                  )}
                  autoComplete='off'
                />

                {formik.touched.ticketSubject && formik.errors.ticketSubject && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.ticketSubject}</span>
                    </div>
                  </div>
                )}
              </div>

              <div className='fv-row mb-7'>
                <label className='fw-semibold fs-5 mb-2'>Mail</label>

                <input
                  placeholder='Mail to'
                  {...formik.getFieldProps('mailTo')}
                  type='text'
                  name='mailTo'
                  className={clsx('form-control form-control custom-input mb-3 mb-lg-0')}
                  autoComplete='off'
                />
              </div>

              <div className='fv-row mb-7'>
                <label className='fw-semibold fs-5 mb-2'>Mail CC</label>

                <input
                  placeholder='Mail to CC'
                  {...formik.getFieldProps('mailToCC')}
                  type='text'
                  name='mailToCC'
                  className={clsx('form-control form-control custom-input mb-3 mb-lg-0')}
                  autoComplete='off'
                />
              </div>

              <div className='fv-row mb-7'>
                <label className='required fw-semibold fs-5 mb-2'>Ticket Message</label>

                <RichTextEditor
                  content={formik.values.ticketMessage}
                  onContentChange={onContentChange}
                  isFile={false}
                />

                {formik.touched.ticketMessage && formik.errors.ticketMessage && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.ticketMessage}</span>
                    </div>
                  </div>
                )}
              </div>

              <div className='fv-row mb-7'>
                <label className='fw-semibold fs-5 mb-2'>Attachment</label>

                <AttachmentMultiple
                  formik={formik}
                  previewUrls={previewUrls}
                  setPreviewUrls={setPreviewUrls}
                  acceptFiles='.png, .jpg, .jpeg'
                  max_file_size={MAX_FILE_SIZE}
                />
              </div>

              <div className='d-flex justify-content-end'>
                <button
                  type='button'
                  className='btn btn-light me-4'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  Close
                </button>
                <button
                  type='submit'
                  className='btn btn-primary'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  Send
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewTicketModal
